
<script>
import { mapGetters, mapActions } from 'vuex';
import { find } from 'lodash';

export default {
  name: 'RefValue',
  props: {
    code: {
      type: [String, Number],
      default: null
    },
    type: {
      type: String,
      default: null
    }
  },
  data: () => ({
    laodgin: true
  }),
  computed: {
    ...mapGetters({ ref: 'referentiel/referentiel', exploitations: 'exploitation/exploitations', tiers: 'user/tiers' })
  },
  async created () {
    if (!this.exploitations) {
      await this.loadExploitations(this.tiers.numTiers);
    }

    this.loading = false;
  },
  methods: {
    ...mapActions({ loadExploitations: 'exploitation/loadExploitations' }),
    buildHtmlAdresse (adresse) {
      const p1 = [adresse.ligneAdresse1 || '', adresse.ligneAdresse2 || '', adresse.ligneAdresse3 || '']
        .map(i => i.trim())
        .filter(i => !!i)
        .join(', ');

      const p2 = adresse.codePostal + ' <wbr>' + adresse.ville;

      return `<span class="line">
                <span>${p1}</span>
                <span class="mx-1">-</span>
                <span>${p2}</span>
              </span>`;
    },
    getHtml () {
      if (this.code === null) {
        return '';
      }

      try {
        switch (this.type) {
          case 'TYPE_SILO':
            if (typeof this.code === 'string' && this.code.startsWith('997:')) {
              return 'Autre (' + this.code.replace('997:', '') + ')';
            }
            return find(this.ref.typesSilo, { code: this.code }).libelle;
          case 'PLAGE_HORAIRE':
            return find(this.ref.periodesLivraison, { code: this.code }).libelle;
          case 'EXPLOITATION':
            return this.buildHtmlAdresse(find(this.exploitations, { numAdr: this.code }).adresse);
          case 'ADRESSE':
            return this.buildHtmlAdresse(find(this.ref.adresses, { numAdr: this.code }));
          default:
            return '--Type non reconnu--';
        }
      } catch (e) {
        if (this.loading) {
          return '--';
        }
        return '--Valeur non reconnue--';
      }
    }
  }
};
</script>

<template>
  <!-- eslint-disable-next-line vue/no-v-html -->
  <span v-html="getHtml()" />
</template>

<style lang="scss" scoped>
// ::v-deep .line{
//   display: inline-block;
// }

::v-deep .line {
  display: inline-flex;
  flex-wrap: wrap;

  & > * {
    display: inline-block;
  }
}
</style>
